import { render } from "./Popup.vue?vue&type=template&id=76478d8c&scoped=true"
import script from "./Popup.vue?vue&type=script&lang=js"
export * from "./Popup.vue?vue&type=script&lang=js"

import "./Popup.vue?vue&type=style&index=0&id=76478d8c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-76478d8c"

export default script